<div class="row">
  <div class="col-xl-12">
    <h3>{{'OnOn' |translate}}</h3>
  </div>
</div>
<!-- Profile editing is part of the AnnaPerenna (legacy) area, which its route requires -->
@if (Areas.AnnaPerenna | can: 'ReadWrite') {
<div class="row mb-3">
  <div class="col-xl-12">
    <a class="btn btn-outline-primary" routerLink="profiles"><span class="fa-light fa-fw fa-id-badge"></span>
  {{'PROFILE_MANAGEMENT' |translate}}</a>
</div>
</div>
}
@for (cameraGroup of cameraGroups; track cameraGroup; let i = $index) {
  @if (i % 6 === 0) {
    <div class="row mb-4">
      @if (cameraGroups[i]) {
        <div class="col-xl-2">
          <onon-monitor-card [cameraGroup]="cameraGroups[i]" [profiles]="profiles"></onon-monitor-card>
        </div>
      }
      @if (cameraGroups[i+1]) {
        <div class="col-xl-2">
          <onon-monitor-card [cameraGroup]="cameraGroups[i+1]" [profiles]="profiles"></onon-monitor-card>
        </div>
      }
      @if (cameraGroups[i+2]) {
        <div class="col-xl-2">
          <onon-monitor-card [cameraGroup]="cameraGroups[i+2]" [profiles]="profiles"></onon-monitor-card>
        </div>
      }
      @if (cameraGroups[i+3]) {
        <div class="col-xl-2">
          <onon-monitor-card [cameraGroup]="cameraGroups[i+3]" [profiles]="profiles"></onon-monitor-card>
        </div>
      }
      @if (cameraGroups[i+4]) {
        <div class="col-xl-2">
          <onon-monitor-card [cameraGroup]="cameraGroups[i+4]" [profiles]="profiles"></onon-monitor-card>
        </div>
      }
      @if (cameraGroups[i+5]) {
        <div class="col-xl-2">
          <onon-monitor-card [cameraGroup]="cameraGroups[i+5]" [profiles]="profiles"></onon-monitor-card>
        </div>
      }
    </div>
  }
}
<div class="row">
  <div class="col-lg-12">
    @if (!cameraGroups) {
      <div>
        <img class="fadeLoader centerLoader logoSmall" src="assets/img/loading_logo.svg">
      </div>
    }
  </div>
</div>
